import React, { memo } from "react";
import { parseBlocks } from "../../chatbot/chat";

function Inline({ parts }) {
  return parts.map((p, i) => (p.kind === "bold" ? <strong key={i}>{p.text}</strong> : p.kind === "code" ? <code key={i} className="px-1 rounded bg-black/30 text-[0.92em]">{p.text}</code> : <React.Fragment key={i}>{p.text}</React.Fragment>));
}

// A chat message as text, paragraphs and lists (never as HTML). dir="auto" shows Urdu, Arabic and Persian from right to left.
function Answer({ text }) {
  return (
    <div dir="auto" className="space-y-2 break-words">
      {parseBlocks(text).map((b, i) => {
        if (b.type === "ul") return <ul key={i} className="list-disc ml-5 space-y-0.5">{b.items.map((parts, j) => <li key={j}><Inline parts={parts} /></li>)}</ul>;
        if (b.type === "ol") return <ol key={i} className="list-decimal ml-5 space-y-0.5">{b.items.map((parts, j) => <li key={j}><Inline parts={parts} /></li>)}</ol>;
        return <p key={i}>{b.lines.map((parts, j) => <React.Fragment key={j}>{j > 0 && <br />}<Inline parts={parts} /></React.Fragment>)}</p>;
      })}
    </div>
  );
}

export default memo(Answer);
